/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_MonthInputs */

const cs_enum_month = /** @type {(inputs: Enum_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`měsíc`)
};

const en_enum_month = /** @type {(inputs: Enum_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`month`)
};

/**
* | output |
* | --- |
* | "month" |
*
* @param {Enum_MonthInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_month = /** @type {((inputs?: Enum_MonthInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_MonthInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_month(inputs)
	return cs_enum_month(inputs)
});